import React from 'react'

const ProfileApprovalTemplate = ({ data }) => {
  const {
    studentName = 'Student',
    approvedDetails = [],
    signatureName = 'Placement Team',
    signatureRole = '',
    signatureInstitute = '',
    signatureContact = ''
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      
      <p style={{ paddingTop: '8px' }}>Dear {studentName},</p>
      
      <p style={{ paddingTop: '8px' }}>
        Your recent profile update request has been reviewed and approved by the TPO.
      </p>

      <p style={{ paddingTop: '12px', fontWeight: 'bold', marginBottom: '8px' }}>Approved Details</p>
      
      <table style={{ borderCollapse: 'collapse', width: '100%', maxWidth: '500px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #333', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Section</th>
            <th style={{ border: '1px solid #333', padding: '8px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Fields</th>
          </tr>
        </thead>
        <tbody>
          {approvedDetails.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #333', padding: '8px' }}>{item.section}</td>
              <td style={{ border: '1px solid #333', padding: '8px' }}>{item.fields}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{ paddingTop: '12px' }}>
        The above details have now been successfully updated in your profile.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureName}</p>
      {signatureRole && <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureRole}</p>}
      {signatureInstitute && <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureInstitute}</p>}
      {signatureContact && <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{signatureContact}</p>}
    </div>
  )
}

export default ProfileApprovalTemplate
